import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";

var $3ca85212bf8898e4$export$fbd65d14c79e28cc = /*#__PURE__*/function () {
  function $3ca85212bf8898e4$export$fbd65d14c79e28cc(collection, ref, options) {
    _classCallCheck(this, $3ca85212bf8898e4$export$fbd65d14c79e28cc);

    this.collection = collection;
    this.ref = ref;
    this.layout = (options === null || options === void 0 ? void 0 : options.layout) || 'stack';
    this.orientation = (options === null || options === void 0 ? void 0 : options.orientation) || 'vertical';
    this.direction = (options === null || options === void 0 ? void 0 : options.direction) || 'ltr';
  }

  return _createClass($3ca85212bf8898e4$export$fbd65d14c79e28cc, [{
    key: "getPrimaryStart",
    value: function getPrimaryStart(rect) {
      return this.orientation === 'horizontal' ? rect.left : rect.top;
    }
  }, {
    key: "getPrimaryEnd",
    value: function getPrimaryEnd(rect) {
      return this.orientation === 'horizontal' ? rect.right : rect.bottom;
    }
  }, {
    key: "getSecondaryStart",
    value: function getSecondaryStart(rect) {
      return this.orientation === 'horizontal' ? rect.top : rect.left;
    }
  }, {
    key: "getSecondaryEnd",
    value: function getSecondaryEnd(rect) {
      return this.orientation === 'horizontal' ? rect.bottom : rect.right;
    }
  }, {
    key: "getFlowStart",
    value: function getFlowStart(rect) {
      return this.layout === 'stack' ? this.getPrimaryStart(rect) : this.getSecondaryStart(rect);
    }
  }, {
    key: "getFlowEnd",
    value: function getFlowEnd(rect) {
      return this.layout === 'stack' ? this.getPrimaryEnd(rect) : this.getSecondaryEnd(rect);
    }
  }, {
    key: "getFlowSize",
    value: function getFlowSize(rect) {
      return this.getFlowEnd(rect) - this.getFlowStart(rect);
    }
  }, {
    key: "getDropTargetFromPoint",
    value: function getDropTargetFromPoint(x, y, isValidDropTarget) {
      var _this = this;

      var _this_ref_current;

      if (this.collection[Symbol.iterator]().next().done || !this.ref.current) return {
        type: 'root'
      };
      var rect = this.ref.current.getBoundingClientRect();
      var primary = this.orientation === 'horizontal' ? x : y;
      var secondary = this.orientation === 'horizontal' ? y : x;
      primary += this.getPrimaryStart(rect);
      secondary += this.getSecondaryStart(rect);
      var flow = this.layout === 'stack' ? primary : secondary;
      var isPrimaryRTL = this.orientation === 'horizontal' && this.direction === 'rtl';
      var isSecondaryRTL = this.layout === 'grid' && this.orientation === 'vertical' && this.direction === 'rtl';
      var isFlowRTL = this.layout === 'stack' ? isPrimaryRTL : isSecondaryRTL;
      var collection = (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.dataset.collection;
      var elements = this.ref.current.querySelectorAll(collection ? "[data-collection=\"".concat(CSS.escape(collection), "\"]") : '[data-key]');
      var elementMap = new Map();

      var _iterator = _createForOfIteratorHelper(elements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _item = _step.value;
          if (_item instanceof HTMLElement && _item.dataset.key != null) elementMap.set(_item.dataset.key, _item);
        } // TODO: assume that only item type items are valid drop targets. This is to prevent a crash when dragging over the loader
        // row since it doesn't have a data-key set on it. Will eventually need to handle the case with drag and drop and loaders located between rows aka tree.
        // Can see https://github.com/adobe/react-spectrum/pull/4210/files#diff-21e555e0c597a28215e36137f5be076a65a1e1456c92cd0fdd60f866929aae2a for additional logic
        // that may need to happen then

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var items = _toConsumableArray(this.collection).filter(function (item) {
        return item.type === 'item';
      });

      var low = 0;
      var high = items.length;

      var _loop = function _loop() {
        var mid = Math.floor((low + high) / 2);
        var item = items[mid];
        var element = elementMap.get(String(item.key));
        if (!element) return 0; // break

        var rect = element.getBoundingClientRect();

        var update = function update(isGreater) {
          if (isGreater) low = mid + 1;else high = mid;
        };

        if (primary < _this.getPrimaryStart(rect)) update(isPrimaryRTL);else if (primary > _this.getPrimaryEnd(rect)) update(!isPrimaryRTL);else if (secondary < _this.getSecondaryStart(rect)) update(isSecondaryRTL);else if (secondary > _this.getSecondaryEnd(rect)) update(!isSecondaryRTL);else {
          var target = {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
          };

          if (isValidDropTarget(target)) {
            // Otherwise, if dropping on the item is accepted, try the before/after positions if within 5px
            // of the start or end of the item.
            if (flow <= _this.getFlowStart(rect) + 5 && isValidDropTarget(_objectSpread(_objectSpread({}, target), {}, {
              dropPosition: 'before'
            }))) target.dropPosition = isFlowRTL ? 'after' : 'before';else if (flow >= _this.getFlowEnd(rect) - 5 && isValidDropTarget(_objectSpread(_objectSpread({}, target), {}, {
              dropPosition: 'after'
            }))) target.dropPosition = isFlowRTL ? 'before' : 'after';
          } else {
            // If dropping on the item isn't accepted, try the target before or after depending on the position.
            var _mid = _this.getFlowStart(rect) + _this.getFlowSize(rect) / 2;

            if (flow <= _mid && isValidDropTarget(_objectSpread(_objectSpread({}, target), {}, {
              dropPosition: 'before'
            }))) target.dropPosition = isFlowRTL ? 'after' : 'before';else if (flow >= _mid && isValidDropTarget(_objectSpread(_objectSpread({}, target), {}, {
              dropPosition: 'after'
            }))) target.dropPosition = isFlowRTL ? 'before' : 'after';
          }

          return {
            v: target
          };
        }
      },
          _ret;

      while (low < high) {
        _ret = _loop();
        if (_ret === 0) break;
        if (_ret) return _ret.v;
      }

      var item = items[Math.min(low, items.length - 1)];
      var element = elementMap.get(String(item.key));
      rect = element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
      if (rect && (primary < this.getPrimaryStart(rect) || Math.abs(flow - this.getFlowStart(rect)) < Math.abs(flow - this.getFlowEnd(rect)))) return {
        type: 'item',
        key: item.key,
        dropPosition: isFlowRTL ? 'after' : 'before'
      };
      return {
        type: 'item',
        key: item.key,
        dropPosition: isFlowRTL ? 'before' : 'after'
      };
    }
  }]);
}();

export { $3ca85212bf8898e4$export$fbd65d14c79e28cc as ListDropTargetDelegate };